module.exports = __webpack_public_path__ + "img/popup15.629fbe55.png";